<template lang="pug">
	.asset-image-generation-edit(v-if="showed && creative && image" v-window)
		.card(@click.stop)
			.card-header
				i.fa.fa-magic
				span AI Image Edit
			.card-body.collapse.show
				.form-line.image.separator
					.images(:class="{centered: true}")
						.image(ref="image" :style="{backgroundImage: `url(${image.path})`}")
							canvas(ref="canvas" width="400px" height="400px" @mousemove="moveBrush($event)" @wheel="changeBrushSize($event)")
							.brush-size(:style="brushSizeStyles")
							.controls
								.control.draw(:class="{selected: control === 'brush'}" @click="control = 'brush'")
									.fa.fa-paint-brush
								.control.erase(:class="{selected: control === 'erase'}" @click="control = 'erase'")
									.fa.fa-eraser
								.control.clean(@click="cleanMask()")
									.fa.fa-trash
				.form-line
					AssetImageGenerationSettings(ref="settings" :creative="creative" :asset="asset" @change="updateSettings($event)")
				.form-actions
					.collapsing-buttons
						button.btn.btn-primary(type="button" @click="generate()")
							i.fa.fa-edit
							span Edit image
					button.btn.btn-dark.right-button(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 				from '../../mixins/screen'

	import AssetImageGenerationSettings			from './AssetImageGenerationSettings'

	export default {
		name: "AssetImageGenerationEdit",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Creative Generations Loaded",
				"Selected Creative Generation Added",
				"Selected Creative Generation Changed: [status]",
				"Selected Creative Generation Removed",
				"Selected Creative Asset Uploads Loaded",
				"Selected Creative Asset Upload Added",
				"Selected Creative Asset Upload Removed",
				"Selected Creative Updated", // для изменения бюджета креатива
				"Selected Version Assets Changed"

			],
			events: {
				"Show AssetImageGenerationEdit": function(creative, asset, variation, image) {

					this.creative = creative;
					this.asset = asset;
					this.variation = variation;
					this.image = image;

					this.update();

				}
			}
		},
		components: {
			AssetImageGenerationSettings
		},
		data() {

			this.creative = null;
			this.asset = null;
			this.image = null;

			return {
				control: "brush",
				size: 15,
				brushSizeStyles: {
					left: 0,
					top: 0,
					width: 1,
					height: 1,
					borderRadius: 1
				}
			}

		},
		methods: {
			collectData() {

				if (!this.creative) return;

				this.$nextTick(() => {

					if (this.$refs["settings"]) this.$refs["settings"].update();

					if (this.$refs["canvas"]) this.initCanvas();

				});

				if (this.$refs["canvas"]) this.initCanvas();

			},
			initCanvas() {

				if (this.canvasInited) return;

				this.canvasInited = true;

				const canvas = this.canvas = this.$refs["canvas"];
				const ctx = this.ctx = canvas.getContext('2d');

				let isDrawing = false;
				let lastX = 0;
				let lastY = 0;

				// Start drawing when mouse is pressed
				canvas.addEventListener('mousedown', (e) => {

					// Get mouse coordinates relative to the canvas
					const rect = canvas.getBoundingClientRect();
					const x = e.clientX - rect.left;
					const y = e.clientY - rect.top;

					isDrawing = true;
					[lastX, lastY] = [x, y];

					if (this.control === 'brush') {

						ctx.beginPath();
						ctx.arc(x + 1, y + 1, this.size / 2, 0, Math.PI * 2);
						ctx.fillStyle = 'turquoise';
						ctx.fill();

					} else if (this.control === 'erase') {

						this.erase(x, y);

					}

				});

				// Stop drawing when mouse is released or leaves the canvas
				window.addEventListener('mouseup', () => {

					isDrawing = false;

				});

				// Draw while the mouse moves
				canvas.addEventListener('mousemove', (e) => {

					if (!isDrawing) return;

					// Get mouse coordinates relative to the canvas
					const rect = canvas.getBoundingClientRect();
					const x = e.clientX - rect.left;
					const y = e.clientY - rect.top;

					if (this.control === 'brush') {

						ctx.beginPath();
						ctx.strokeStyle = 'turquoise';
						ctx.lineWidth = this.size;
						ctx.lineCap = 'round';
						ctx.lineJoin = 'round';

						ctx.moveTo(lastX, lastY);

						const midX = (lastX + x) / 2;
						const midY = (lastY + y) / 2;

						ctx.quadraticCurveTo(lastX, lastY, midX, midY);

						ctx.stroke();

						[lastX, lastY] = [x, y];

					} else if (this.control === 'erase') {

						this.erase(x, y);

					}

				});

			},
			erase(x, y) {

				this.ctx.save();

				// Set the "eraser" mode
				this.ctx.globalCompositeOperation = 'destination-out';

				this.ctx.beginPath();
				this.ctx.arc(x + 1, y + 1, this.size / 2, 0, Math.PI * 2);
				this.ctx.fill();

				this.ctx.restore();

			},
			cleanMask() {

				this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

			},
			moveBrush(e) {

				const rect = this.$refs['image'].getBoundingClientRect();

				// Вычисляем координаты мыши относительно родителя
				const x = e.clientX - rect.left;
				const y = e.clientY - rect.top;

				// Центрируем див по курсору (вычитаем половину его размера)
				this.brushSizeStyles.left = `${x - this.size / 2}px`;
				this.brushSizeStyles.top = `${y - this.size / 2}px`;
				this.brushSizeStyles.width = `${this.size}px`;
				this.brushSizeStyles.height = `${this.size}px`;
				this.brushSizeStyles.borderRadius = `${this.size}px`;

			},
			changeBrushSize(e) {

				if (e.deltaY > 0) {

					this.size += 1;

				} else {

					this.size -= 1;

				}

				this.moveBrush(e);

			},
			generate() {

				let settings = this.$refs["settings"].getSettings();

				Server.sendToServer({
					GenerateImage: {
						versionId: this.asset['version_id'],
						assetCodename: this.asset['codename'],
						aiVendorCodename: settings.vendorCodename,
						aiModelCodename: settings.modelCodename,
						aiStyleCodenames: settings.styleCodenames,
						aiSizeCodename: settings.sizeCodename,
						prompt: settings.prompt,
						attachments: Object.keys(this.attachments),
						count: settings.count,
						// Генерация без ассета здесь не используется - он уже есть
						newAssetCodename: '',
						newElementType: '',
						elementScreenCodename: '',
						elementId: 0
					}
				});

			}
		}
	}
</script>

<style lang="sass">

	.asset-image-generation-edit
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		transition: all .3s, opacity 0.2s

		.card-wrapper
			display: flex
			margin: auto
			transition: 0.3s

		.card-header

			.collapse-left
				margin-left: auto

				.fa
					font-size: 18px
					margin-top: 4px
					margin-bottom: 3px
					width: 15px

		.description
			align-items: center

			.collapse-left

				.fa
					font-size: 18px
					margin-top: 4px
					margin-bottom: 3px
					width: 15px

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 940px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)
			transition: 0.2s

			button
				white-space: nowrap

				i
					margin-right: 10px

			.btn-ghost-dark, .btn-dark
				color: #fff

			.btn-link
				color: #fff

			.btn-link:hover
				color: #fff

		.form-group
			display: flex
			flex-direction: column
			margin: 0

			&:first-child
				margin-left: 0

		.form-line
			display: flex
			flex-direction: row

		.field-title
			margin-bottom: 5px
			cursor: default
			color: var(--gray)

		.images
			display: flex
			flex-direction: row
			width: 100%

			&.centered
				justify-content: center

			.image
				flex-shrink: 0
				width: 400px
				height: 400px
				background-position: center
				background-size: contain
				background-repeat: no-repeat
				border-radius: 5px
				border: 1px solid var(--gray-dark)
				box-shadow: 0px 0px 5px var(--gray-dark)
				cursor: pointer
				position: relative

				&:hover
					border-color: var(--primary)

				.brush-size
					display: none
					border: 1px solid var(--primary)
					pointer-events: none
					position: absolute

				.controls
					display: flex
					flex-direction: column
					position: absolute
					right: -45px
					bottom: 0
					font-size: 18px

					.control
						display: flex
						justify-content: center
						align-items: center
						width: 40px
						height: 40px
						cursor: pointer

						&.selected
							color: var(--orange)

						&:hover
							color: var(--primary)

			.image:has(canvas:hover)

				.brush-size
					display: flex

			canvas
				opacity: 0.7

		.form-actions
			display: flex
			flex-direction: row
			align-items: center
			margin-top: 20px
			transition: 0.3s

			.right-button
				margin-left: auto

			.upload-image
				margin-left: 20px

	.asset-image-generation-edit.hiding
		opacity: 0

		.card
			transform: scale(0.9)

</style>

